import {createContext, useContext, useState, ReactNode} from 'react'
import {CDREntitiesContextProps, CDREntitiesState, ICDRLine, ICDRUser} from '../core/_models'

const initial: CDREntitiesContextProps = {
  state: {users: [], lines: []},
  setUsers: () => {},
  setLines: () => {},
}

const CDREntitiesContext = createContext<CDREntitiesContextProps>(initial)

export const CDREntitiesProvider = ({children}: {children?: ReactNode}) => {
  const [state, setState] = useState<CDREntitiesState>({users: [], lines: []})

  const setUsers = (users: ICDRUser[]) => {
    setState((prev) => ({...prev, users}))
  }

  const setLines = (lines: ICDRLine[]) => {
    setState((prev) => ({...prev, lines}))
  }

  return <CDREntitiesContext.Provider value={{state, setUsers, setLines}}>{children}</CDREntitiesContext.Provider>
}

export const useQueryCDREntitiesRequest = () => useContext(CDREntitiesContext)
